import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@app-core/constants/api.constants';
import { setParams } from '@app-core/models/core.model';
import { DataService } from '@app-core/services/data/data.service';
import { UserLogListMapping } from '@app-user-management/constants/user-activity-log.constants';
import {
  UserLogDetailsResponse,
  UserLogListResponse,
  UsersLogDetailParams,
  UsersLogListParams,
} from '@app-user-management/models/users.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserActivityLogService {
  constructor(private http: HttpClient, public dataService: DataService) {}

  public getUserLogList(params: UsersLogListParams): Observable<UserLogListResponse> {
    const httpOptions = {
      params: setParams(params),
    };
    return this.http.get<UserLogListResponse>(API.GET_USERS_LOG_LIST, httpOptions);
  }

  public getUserActivityViewDetails(params: UsersLogDetailParams): Observable<UserLogDetailsResponse> {
    const httpOptions = {
      params: setParams(params),
    };
    return this.http.get<UserLogDetailsResponse>(API.GET_USERS_LOG_DETAILS, httpOptions);
  }

  public getActivityLabelByType(activityType: string) {
    const mappingEntry = Object.values(UserLogListMapping).find((entry) => entry.key === activityType);
    return mappingEntry?.label || activityType;
  }
}
